import * as React from 'react';

function SvgYoutube(props) {
    return (
        <svg width={34} height={26} viewBox="0 0 34 26" {...props}>
            <path
                d="M27.102 1.133c-4.9-.333-15.81-.332-20.703 0C1.1 1.494.477 4.686.438 13.088c.04 8.387.658 11.593 5.96 11.955 4.894.332 15.805.334 20.704 0 5.297-.36 5.921-3.553 5.96-11.955-.039-8.387-.657-11.593-5.96-11.955zm-14.43 17.38V7.663l10.875 5.415-10.875 5.433z"
                fillRule="nonzero"
            />
        </svg>
    );
}

export default SvgYoutube;
